<div class="twofa-nag" fxLayout="column" fxLayoutGap="12px">
  <div class="head">
    <h3 class="title">Protect Your Account with 2FA</h3>
    <p class="subtitle">
      For your security and peace of mind, we strongly recommend activating Two-Factor Authentication (2FA).
      It only takes a minute — and it adds an extra layer of protection to your AUMENT account.
    </p>
  </div>

  <ul class="benefits">
    <li>Secure your assets</li>
    <li>Prevent unauthorized access</li>
    <li>Stay in full control</li>
  </ul>

  <p class="cta-sub">Choose your preferred method (SMS, Email or Authenticator App) to get started.</p>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="actions">
    <button mat-button class="later" (click)="dismiss()">Maybe later</button>
    <button mat-raised-button color="primary" class="activate" (click)="activate()">ACTIVATE 2FA NOW</button>
  </div>
</div>
